import React, { ReactElement } from 'react'
import { TlayoutWithChild } from '@/types/layout'


type TProps = {
  breadcrumb?: string
  userPage?: boolean
  children?: React.ReactNode | any
}

export const BlankLayout: TlayoutWithChild & React.FC<TProps> = ({ children }) => {
  return (
    <div className="app text-black">
      <div>{children}</div>
    </div>
  )
}

BlankLayout.getLayout = (page: ReactElement) => <BlankLayout>{page}</BlankLayout>
